module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAYAAAAAwr0iAAAAAXNSR0IArs4c6QAAAKhJREFUSA3tlyEOwkAQRbdAg6vgBqiapqK2oqYKj+2hansKErhEkybo3oBgCKIIDO8fADsrOj95a9/mi5lMEkI4wwm2YJUF0QDTjqeGPVgmQ1bBlPAU0MAGrKIGrvCwErrHG/AGvIG/DWgSxtgFb7w9zLF2wQF5qQ/E2gVq4AIv8HgD3oA3sPIGNIqP0IL2glU+iG7wlLSDHKyTIhx0jIzwNbbrMLnL+QPENRZv0wYPRwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/menu.png
// module id = 2oj2
// module chunks = 1